/* global transitionEnd */
/* eslint angular/document-service:0 */
/* eslint angular/no-run-logic:0 */
/* eslint angular/timeout-service:0 */
/* eslint angular/window-service:0 */
/* eslint-disable no-empty */
/* eslint-disable no-undef */

import * as Sentry from '@sentry/browser';
import { initializeLDClient } from './global/plugins/launchdarkly';

(function () {
    'use strict';

    var getToken = function () {
        var metaTags = document.getElementsByTagName('meta');

        for (var i = 0; i < metaTags.length; i++) {
            if (metaTags[i].getAttribute !== undefined && metaTags[i].getAttribute('name') === 'csrf-token') {
                return metaTags[i].getAttribute('content');
            }
        }

        return '';
    };

    var checkLoaded = function () {
        if (!config.loaded) {
            setTimeout(checkLoaded, 100);
            return;
        }

        angular.element(document.body).addClass('loaded');
    };

    var checkIfMSEdge = function () {
        var ua = window.navigator.userAgent;
        config.MSEdge = ua.toLowerCase().indexOf('edge') > 0;
    };

    var checkIfFirefox = function () {
        var ua = window.navigator.userAgent;
        config.firefox = ua.indexOf('Firefox') >= 0;
    };

    var checkIfSafari = function () {
        var ua = window.navigator.userAgent;
        config.safari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
    };

    var checkCookiesEnabled = function () {
        var cookieEnabled = !!(navigator.cookieEnabled);

        if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }

        config.cookieEnabled = cookieEnabled;
    };

    var checkTransitionEndEnabled = function () {
        var supported = transitionEnd(document.body).whichTransitionEnd();

        if (!supported) {
            angular.element(document.body).addClass('no-transition-end');
            config.noTransitionEnd = true;
        }
    };

    var checkLocalStorage = function () {
        var s = 'thankview';
        try {
            window.localStorage.setItem(s, s);
            window.localStorage.removeItem(s);
            config.localStorage = true;
        } catch (e) {
            config.localStorage = false;
        }
    };

    var storeUTMCodes = function () {
        if (!config.localStorage || !window.location.search) {
            return;
        }

        var params = { utm_source: true, utm_medium: true, utm_campaign: true };
        var url = window.location.search;
        var query = url.substr(1);
        query.split('&').forEach(function (part) {
            var item = part.split('=');
            if (params[item[0]]) {
                window.localStorage.setItem(item[0], decodeURIComponent(item[1]));
            }
        });
    };

    var browserSupportsPassiveEvents = function () {
    // Test via a getter in the options object to see if the passive property is accessed
        var supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line getter-return
                get: function () {
                    supportsPassive = true;
                },
            });
            window.addEventListener('testPassive', null, opts);
            window.removeEventListener('testPassive', null, opts);
        } catch (e) {}
        config.supportsPassive = supportsPassive;
    };

    angular.module('thankview.global', ['ui.bootstrap'])
        .value('csrfToken', getToken())
        .factory('$exceptionHandler', [function () {
            return function (exception, cause) {
                Sentry.captureException(exception, {
                    extra: { cause: cause },
                });
                console.error('Unhandled exception:', exception, 'Cause:', cause);
            };
        }])
        .run(['$rootScope', function ($rootScope) {
            const userInfo = {
                key: config.user?.id || 'anonymous',
                name: config.user?.name,
                email: config.user?.email,
            };

            const oid = config.user?.et_oid || null;
            const slug = config.userBusinessSlug || null;

            const ldClient = initializeLDClient(userInfo, oid, slug);

            ldClient.on('ready', () => {
                $rootScope.featureFlags = ldClient.allFlags();
                $rootScope.getFeatureFlag = (flagKey) => ldClient.variation(flagKey, false);
                $rootScope.$apply();
            });

            var checkIsMobile = function () {
                $rootScope.isMobile = window.config.isMobile || window.screen.width <= 768;
            };

            try {
                // AngularJS errors reach Sentry through the $exceptionHandler factory above;
                // @sentry/browser 8+ has no Angular integration or configureScope.
                Sentry.init({
                    dsn: config.sentryDSN,
                    environment: config.env || 'production',
                    release: config.version || '1.0.0',
                    tracesSampleRate: 1.0,
                });

                if (config.user) {
                    Sentry.setUser({
                        id: config.user.id,
                        email: config.user.email,
                        username: config.user.name,
                    });
                }
            } catch (error) {
                console.error('Sentry initialization failed:', error);
            }

            // Capture unhandled AngularJS exceptions
            $rootScope.$on('$routeChangeError', function (event, current, previous, rejection) {
                Sentry.captureException(new Error(`Route Change Error: ${rejection}`));
            });

            var setMSEdge = function () {
                $rootScope.MSEdge = config.MSEdge;
            };

            var setSafari = function () {
                $rootScope.safari = config.safari;
            };

            var checkBusiness = function () {
                if (config.user && config.user.business) {
                    $rootScope.business = config.user.business;
                } else {
                    $rootScope.business = window.location.hostname.replace(config.hostUrl, '').split('.')[0];
                }

                if (config.params && config.params.package) {
                    $rootScope.currentPackage = config.params.package;
                }

                if (config.params && config.params.upcomingPackage) {
                    $rootScope.upcomingPackage = config.params.upcomingPackage;
                }
            };

            var setConfigUser = function () {
                if (config.user) {
                    config.user.firstName = config.user.name.split(' ')[0];

                    $rootScope.configUser = config.user;
                }
            };

            var setCurrentProject = function () {
                $rootScope.currentProject = config.params ? config.params.project : undefined;
                if ($rootScope.currentProject && $rootScope.currentProject.project_type && $rootScope.currentProject.project_type.slug === 'video-request') {
                    $rootScope.currentProject.guest_type = 'Recorder';
                } else if ($rootScope.currentProject) {
                    $rootScope.currentProject.guest_type = 'Recipient';

                    if ($rootScope.currentProject.intro) {
                        $rootScope.currentProject.color_type = $rootScope.currentProject.intro.color_type;
                        $rootScope.currentProject.font_id = $rootScope.currentProject.intro.font_id;
                        $rootScope.currentProject.music_id = $rootScope.currentProject.intro.music_id;
                        $rootScope.currentProject.message = $rootScope.currentProject.intro.message;
                        $rootScope.currentProject.message_2 = $rootScope.currentProject.intro.message_2;
                        $rootScope.currentProject.title = $rootScope.currentProject.intro.title;
                    }
                }
                console.log('currentProject is', $rootScope.currentProject);
            };

            var setCurrentList = function () {
                $rootScope.currentList = config.params ? config.params.currentList : undefined;
                console.log('currentList is', $rootScope.currentList);
            };

            var setUserRoles = function () {
                var roles = {};
                var roleValue = 0;

                if (config.user && config.params?.roles) {
                    angular.forEach(config.params.roles, function (role) {
                        roleValue = Math.max(roleValue, parseInt(role.value, 10));
                        roles[role.slug] = true;
                    });
                }

                $rootScope.roles = roles;
                $rootScope.roleValue = roleValue;
                console.log($rootScope.roles);
            };

            $rootScope.cdnPath = config.cdnPath;
            $rootScope.assetUrlRoot = config.assetUrlRoot;

            /**
             * Map of our standard breakpoints, matching those set in our CSS framework
             * Properties are key / value pairs, the same as in css
             * Values are integers, representing number of pixels
             */
            $rootScope.standardBreakpoints = {
                sm: 576,
                md: 768,
                lg: 1024,
                xl: 1366,
                xxl: 1920,
            };

            /**
            * Helper function for copying text to clipboard
            * @param {*} text the value to copy
            * @param {*} callback function to call after successfully copying to clipboard
            */
            $rootScope.copyToClipboard = function (text, successCallback, errorCallback = null) {
                if (!errorCallback) {
                    errorCallback = () => {
                        console.log('Error copying to clipboard');
                    };
                }
                const id = 'tv-clipboard-textarea';
                let existsTextarea = document.getElementById(id);
                if (!existsTextarea) {
                    const textarea = document.createElement('textarea');
                    textarea.id = id;
                    textarea.readOnly = true;
                    textarea.style.position = 'fixed';
                    textarea.style.top = 0;
                    textarea.style.left = 0;
                    textarea.style.width = '1px';
                    textarea.style.height = '1px';
                    textarea.style.padding = 0;
                    textarea.style.border = 'none';
                    textarea.style.outline = 'none';
                    textarea.style.boxShadow = 'none';
                    textarea.style.background = 'transparent';
                    document.querySelector('body').appendChild(textarea);
                    existsTextarea = document.getElementById(id);
                }

                existsTextarea.value = text;
                existsTextarea.select();

                try {
                    const status = document.execCommand('copy');
                    if (!status) errorCallback();
                    else successCallback();
                } catch (err) {
                    errorCallback();
                }
            };

            browserSupportsPassiveEvents();
            checkLoaded();
            checkIfMSEdge();
            checkIfFirefox();
            checkIfSafari();
            checkCookiesEnabled();
            checkTransitionEndEnabled();
            checkIsMobile();
            checkBusiness();
            setConfigUser();
            setUserRoles();
            setMSEdge();
            setSafari();
            setCurrentProject();
            setCurrentList();
            checkLocalStorage();
            storeUTMCodes();
        }]);
}());
